import React from 'react';
import { FaGamepad } from 'react-icons/fa';

/**
 * GamepadIcon
 * Ikona gamepadu pre ovládacie alebo simulačné akcie.
 */
const GamepadIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FaGamepad className={className} {...props} />
);

export default GamepadIcon;

